module.exports = __webpack_public_path__ + "static/media/borde.0252d9c9.svg";